import { useTranslation } from 'react-i18next'
import { Fragment } from 'react'
import { useLocation } from 'react-router-dom'
import {
  Box,
  Text,
  Columns,
  Column,
  MenuRenderer,
  MenuItem,
  IconChevronDown,
  IconChevronUp
} from '@machobear/design-system'
import { vars } from '@machobear/design-system/css'
import { useHistory } from 'react-router-dom'
import { GraphBarAlt, GridAlt, RocketAlt, FileLockAlt, EditAlt } from '@/components/icons'
import * as styles from '../../index.css'

const MobileMenu = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const history = useHistory()
  const pathName = location.pathname

  const SUBPRODUCT_OPTIONS = [
    {
      title: t('l.credit_usage.sidemenu.tenant_screening.label', 'Tenant Screening'),
      description: t(
        'l.credit_usage.sidemenu.tenant_screening.text',
        'View tenant screening reports.'
      ),
      icon: FileLockAlt,
      to: '/usage-credits/products/tenant-screening',
      key: ['tenant-screening']
    },
    {
      title: t('l.credit_usage.sidemenu.rental_advertising.label', 'Rental Advertising'),
      description: t(
        'l.credit_usage.sidemenu.rental_advertising.text',
        'View rental advertising products.'
      ),
      icon: RocketAlt,
      to: '/usage-credits/products/rental-advertising',
      key: ['rental-advertising']
    },
    {
      title: t('l.credit_usage.sidemenu.lease_payments.label', 'Lease & Payments'),
      description: t(
        'l.credit_usage.sidemenu.lease_payments.text',
        'View lease & payment products.'
      ),
      icon: EditAlt,
      to: '/usage-credits/products/lease-payments',
      key: ['lease-payments']
    }
  ]

  const PRODUCT_OPTIONS = [
    {
      title: t('b.useage.credits.my_products.text', 'My Products'),
      description: t(
        'l.credit_usage.sidemenu.my_products.text',
        'View your products and their usage.'
      ),
      icon: GraphBarAlt,
      to: '/usage-credits/products/my-products',
      key: ['my-products']
    },
    {
      title: t('l.credit_usage.sidemenu.all_products.label', 'All Products'),
      description: t('l.credit_usage.sidemenu.all_products.text', 'View all products.'),
      icon: GridAlt,
      to: '/usage-credits/products/all',
      key: ['all'],
      submenuItems: SUBPRODUCT_OPTIONS
    }
  ]
  const activePath = [...PRODUCT_OPTIONS, ...SUBPRODUCT_OPTIONS].find(x => pathName === x.to)
  const activePathIndex = [...PRODUCT_OPTIONS, ...SUBPRODUCT_OPTIONS].findIndex(
    x => pathName === x.to
  )

  return (
    <MenuRenderer
      offsetSpace="none"
      width="content"
      trigger={(triggerProps, { open }) => (
        <Box
          paddingX="gutter"
          style={{ paddingTop: vars.space.gutter }}
          userSelect="none"
          cursor="pointer"
          marginBottom="gutter"
          {...triggerProps}
        >
          <Text weight="strong" size="medium">
            {activePath?.title} {open ? <IconChevronUp /> : <IconChevronDown />}
          </Text>
        </Box>
      )}
      initialSelected={activePathIndex}
      menuPosition="fixed"
    >
      {PRODUCT_OPTIONS.map(item => {
        const Icon = item.icon

        return (
          <Fragment key={item.key[0]}>
            <MenuItem onClick={() => history.push(item.to)}>
              <Box
                padding="none"
                width="full"
                onClick={() => {
                  history.push(item.to)
                }}
              >
                <Columns space="xxxxsmall" alignY="center">
                  <Column width="content">
                    <Box display="flex" className={styles.iconWrapper}>
                      <Icon width={20} />
                    </Box>
                  </Column>
                  <Column>{item.title}</Column>
                </Columns>
              </Box>
            </MenuItem>
            {item?.submenuItems?.map((item: any) => {
              const Icon = item.icon

              return (
                <MenuItem onClick={() => history.push(item.to)} key={item.key[0]}>
                  <Box paddingLeft="gutter" width="full" display="flex">
                    <Columns space="xxsmall" alignY="center">
                      <Column width="content">
                        <Box width="full" className={styles.iconWrapper}>
                          <Icon width={16} />
                        </Box>
                      </Column>
                      <Column>{item.title}</Column>
                    </Columns>
                  </Box>
                </MenuItem>
              )
            })}
          </Fragment>
        )
      })}
    </MenuRenderer>
  )
}

export default MobileMenu
